import { render, staticRenderFns } from "./BtnList.vue?vue&type=template&id=588e780d&"
import script from "./BtnList.vue?vue&type=script&lang=js&"
export * from "./BtnList.vue?vue&type=script&lang=js&"
import style0 from "./BtnList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports